import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import HomeAnnouncements from '../../components/HomeAnnouncements';
import About from '../../components/About';
import BoardMembers from '../../components/BoardMembers';
import Gallery from '../../components/Gallery';
import Tribute from '../../components/Tribute';
import Contact from '../../components/Contact';
import { fetchHomeData } from '../../services/api';
import FAQSection from '../../components/faq/FaqSection';
import Slider from '../../components/Slider';

const Home = () => {
  const { hash } = useLocation();

  // Add sample tribute data
  const sampleData = {
    announcements: [],
    boardMembers: [],
    gallery: [],
    tribute: {
      name: "John Doe",
      image: "/images/tribute.jpg", // Update with your tribute image
      description: "The entire Hamsa Lomi family is saddened by the loss of John Doe. We honor his memory and contributions to our organization."
    }
  };

  const [data, setData] = useState(sampleData);  // Initialize with sample data
  const [loading, setLoading] = useState(true);

  // Scroll to section when navigating from another page with hash (e.g. /#about)
  // Defer scroll until after paint so the correct section is in the DOM and layout is complete
  useEffect(() => {
    if (!hash || loading) return;
    const id = hash.replace('#', '');
    const scrollToSection = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    const frameId = requestAnimationFrame(() => {
      requestAnimationFrame(scrollToSection);
    });
    return () => cancelAnimationFrame(frameId);
  }, [hash, loading]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetchHomeData();
        setData(response.data);
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <Box>
      <HomeAnnouncements announcements={data.announcements} />
      <div>
        <Slider />
      </div>
      <div style={{ backgroundColor: "white" }} id='about'>
        <About />
      </div>
      <div id='boardMembers'>
        <BoardMembers members={data.boardMembers} />
      </div>
      <div id='gallery'>
        <Gallery images={data.gallery} />
      </div>
      <div id='tribute'>
        <Tribute tribute={data.tribute} />
      </div>
      <div>
        <FAQSection />
      </div>
      <div id='contact'>
        <Contact />
      </div>
    </Box>
  );
};

export default Home; 